import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../FirebaseConfig';

export const signInWithEmail = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    // Logging para depuração de erros 400 (INVALID_PASSWORD, USER_DISABLED, etc)
    // Não mostramos alert aqui para não quebrar UX; o componente chamador decide o feedback.
    // eslint-disable-next-line no-console
    console.error('Firebase signIn error:', error?.code, error?.message);
    throw error;
  }
};
